// extracted by mini-css-extract-plugin
var _1 = "F8xFK";
var _2 = "K2SBY";
export { _1 as "button", _2 as "inverse" }
